import React from 'react';
import Loader from '~/App/Components/Shared/Loader';
import { PublishPageContext } from '~/App/Modules/Testimonials/Pages/Publish/Editor/Contexts/PublishPageContext';
import {
  PublishableContext,
  usePublishable,
} from '~/Share/Publishable/use-publishable';
import {
  Publishable,
  PublishableStatus,
  PublishableTestimonial,
} from '~/types/models/publishable';
import { SocialType } from '@vimily/bonjoro-ui-components-v2';
import { Publish } from './Publish';
import { usePreviousFontFamily } from '~/react-hooks/use-previous-font-family';

declare global {
  const publishableResource: {
    publishable: Publishable;
    publishableResources: PublishableTestimonial[];
    hideBonjoroBadge: boolean;
  };
}

export default function PublishableLandingPage() {
  return (
    <PublishableContext.Provider value={publishableResource}>
      <LandingPageParser />
    </PublishableContext.Provider>
  );
}

function LandingPageParser() {
  const { publishable, publishableResources, hideBonjoroBadge } =
    usePublishable();
  const { value: previousFontFamily } = usePreviousFontFamily();

  // Filters out the empty twitter content (Loading/Queued)
  const assets = publishableResources.filter(
    (resource) =>
      resource.type != SocialType.Twitter ||
      (resource.type === SocialType.Twitter && resource.content != null)
  );

  const showEmptyScreen =
    publishable.status != PublishableStatus.Live || assets.length === 0;

  if (showEmptyScreen) {
    return <div className='bg-white' />;
  }

  if (publishable && assets) {
    return (
      <PublishPageContext.Provider
        value={{
          publish: {
            ...publishable,
            publishable_resources: assets,
          },
        }}
      >
        <Publish
          hideBonjoroBadge={hideBonjoroBadge}
          containerStyle={{
            fontFamily:
              publishable?.metadata?.style?.font_family ?? previousFontFamily,
          }}
        />
      </PublishPageContext.Provider>
    );
  }

  return (
    <div className='flex pt-0 w-full h-full bg-fixed bg-cover justify-center relative'>
      <div className='p-[30px] m-auto flex flex-col justify-center items-center w-full'>
        <Loader />
      </div>
    </div>
  );
}
